<template>
  <div class="whole-vehicle-list">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>整车保</span>
      </div>
      
      <!-- 搜索工具栏 -->
      <div class="search-toolbar">
        <el-form :inline="true" :model="searchForm" class="demo-form-inline">
          <el-form-item label="投保人">
            <el-input v-model="searchForm.policyholder" placeholder="投保人" clearable></el-input>
          </el-form-item>
          
          <el-form-item label="被保险人">
            <el-input v-model="searchForm.beneficiary" placeholder="被保险人" clearable></el-input>
          </el-form-item>
          
          <el-form-item label="手机号">
            <el-input v-model="searchForm.mobile" placeholder="手机号码" clearable></el-input>
          </el-form-item>
          
          <el-form-item label="保单号">
            <el-input v-model="searchForm.policyNo" placeholder="保单号" clearable></el-input>
          </el-form-item>
          
          <el-form-item label="车牌号">
            <el-input v-model="searchForm.carNo" placeholder="车牌号" clearable></el-input>
          </el-form-item>
          
          <el-form-item label="投保时间">
            <el-date-picker
              v-model="searchForm.insuranceDateRange"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="timestamp">
            </el-date-picker>
          </el-form-item>
          
          <el-form-item label="投保状态">
            <el-select v-model="searchForm.status" placeholder="请选择状态" clearable>
              <el-option label="生效" value="4"></el-option>
              <el-option label="完成" value="8"></el-option>
              <el-option label="理赔中" value="16"></el-option>
              <el-option label="理赔完成" value="32"></el-option>
              <el-option label="未支付" value="1"></el-option>
              <el-option label="已取消" value="2"></el-option>
            </el-select>
          </el-form-item>
          
          <el-form-item label="生效时间">
            <el-date-picker
              v-model="searchForm.effectiveDateRange"
              type="daterange"
              range-separator="至"
              start-placeholder="生效时间"
              end-placeholder="失效时间"
              value-format="timestamp">
            </el-date-picker>
          </el-form-item>
          
          <el-form-item label="保额">
            <el-select v-model="searchForm.coverage" placeholder="请选择保额" clearable>
              <el-option label="50万" value="500000"></el-option>
              <el-option label="150万" value="1500000"></el-option>
            </el-select>
          </el-form-item>
          
          <el-form-item label="公里数">
            <span style="margin: 0 4px">开始距离:</span>
            <el-input v-model="searchForm.beginDistance" style="width: 100px;"></el-input>
            <span style="margin: 0 4px">结束距离:</span>
            <el-input v-model="searchForm.endDistance" style="width: 100px;"></el-input>
          </el-form-item>
          
          <el-form-item label="渠道商">
            <!-- 渠道商输入框 -->
            <el-autocomplete
              v-model="searchForm.channel"
              :fetch-suggestions="queryChannel"
              placeholder="渠道商"
              clearable
              style="width: 200px;"
              @select="handleChannelSelect"
            >
              <template slot-scope="{ item }">
                <div>{{ item.realname }} {{ item.alias ? '(' + item.alias + ')' : '' }}</div>
              </template>
            </el-autocomplete>
          </el-form-item>
          
          <el-form-item>
            <el-button type="primary" @click="handleSearch">搜索</el-button>
            <el-button @click="handleReset">重置</el-button>
            <el-button type="success" @click="handleExportExcel">导出Excel</el-button>
          </el-form-item>
        </el-form>
      </div>
      
      <!-- 保费总额显示 -->
      <div class="premium-total">
        保费总额：<span class="total-amount">¥{{ formatMoney(premiumTotal) }}</span>
      </div>
      
      <!-- 数据表格 -->
      <el-table
        :data="tableData"
        style="width: 100%"
        border
        v-loading="loading"
        @selection-change="handleSelectionChange">
        <el-table-column prop="policyholder" label="投保人" width="270" align="center">
          <template slot-scope="scope">
            <span class="link" @click="viewPolicyholderDetail(scope.row.policyholder)">
              {{ scope.row.policyholder }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="beneficiary" label="被保险人" width="270" align="center">
          <template slot-scope="scope">
            <span class="link" @click="viewPolicyholderDetail(scope.row.beneficiary)">
              {{ scope.row.beneficiary }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="mobile" label="手机号" width="180" align="center"></el-table-column>
        <el-table-column prop="channel_name" label="渠道" width="160" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.channel_name">
              {{ scope.row.channel_name }}({{ scope.row.alias }})
            </span>
            <span v-else>{{ scope.row.alias }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="policy_no" label="保单号" width="240" align="center">
          <template slot-scope="scope">
            <span class="link" @click="viewOrderDetail(scope.row.id)">
              {{ scope.row.policy_no || '保单详情' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="type" label="保单种类" width="70" align="center" :formatter="policyTypeFormat"></el-table-column>
        <el-table-column prop="is_trial" label="保单类型" width="55" align="center" :formatter="policyTrialFormat"></el-table-column>
        <el-table-column prop="source" label="来源" width="110" align="center" :formatter="sourceFormat"></el-table-column>
        <el-table-column prop="coverage" label="保额" width="155" align="center" :formatter="coverageFormat"></el-table-column>
        <el-table-column prop="plate_no" label="车牌号" width="240" align="center" :formatter="plateNoFormat"></el-table-column>
        <el-table-column prop="haulway" label="运输路线" width="300" align="center" :formatter="haulwayFormat"></el-table-column>
        <el-table-column prop="distance" label="距离" width="80" align="center" :formatter="distanceFormat"></el-table-column>
        <el-table-column prop="carriage" label="运费" width="100" align="center" :formatter="moneyFormat"></el-table-column>
        <el-table-column prop="price" label="原价" width="100" align="center" :formatter="moneyFormat"></el-table-column>
        <el-table-column prop="pay_price" label="实付" width="100" align="center" :formatter="moneyFormat"></el-table-column>
        <el-table-column prop="created_at" label="投保时间" width="240" align="center" :formatter="dateFormat"></el-table-column>
        <el-table-column prop="status" label="保单状态" width="70" align="center" :formatter="statusFormat"></el-table-column>
        <el-table-column prop="effected_at" label="生效时间" width="240" align="center" :formatter="dateFormat"></el-table-column>
        <el-table-column prop="expired_at" label="结束时间" width="240" align="center" :formatter="dateFormat"></el-table-column>
        <el-table-column prop="policy_notify_success" label="保单信息回传" width="140" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.policy_no && scope.row.status == 4">
              <span v-if="scope.row.policy_notify_success">已回传</span>
              <el-button v-else size="mini" @click="handlePolicyCallback(scope.row.id)">手动回传</el-button>
            </span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="120" align="center">
          <template slot-scope="scope">
            <el-button 
              size="mini" 
              :type="scope.row.note_count > 0 ? 'danger' : ''"
              @click="handleNote(scope.row.id, scope.row.user_id)">
              {{ scope.row.note_count > 0 ? '备注(' + scope.row.note_count + ')' : '备注' }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      
      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagination.currentPage"
        :page-sizes="[10, 15, 20, 25]"
        :page-size="pagination.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagination.total"
        style="margin-top: 20px;">
      </el-pagination>
    </el-card>
    
    <!-- 备注对话框 -->
    <el-dialog
      title="整车保备注信息"
      :visible.sync="noteDialogVisible"
      width="600px"
      @close="handleNoteDialogClose">
      <div class="note-content">
        <el-table
          :data="noteList"
          style="width: 100%"
          border
          v-loading="noteLoading">
          <el-table-column prop="created_at" label="时间" width="150" :formatter="dateFormat"></el-table-column>
          <el-table-column prop="content" label="备注内容"></el-table-column>
          <el-table-column prop="operator" label="操作人" width="100"></el-table-column>
        </el-table>
        
        <div class="add-note">
          <el-input
            type="textarea"
            v-model="newNoteContent"
            placeholder="请输入备注内容"
            :rows="3"
            maxlength="200"
            show-word-limit>
          </el-input>
          <div style="margin-top: 10px; text-align: right;">
            <el-button @click="handleAddNote" type="primary">添加备注</el-button>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="noteDialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { formatDate, formatMoney } from '@/utils/formatter'
import { zcbOrderList, zcbExportOrder, zcbPolicyCallback, getChannelList } from '@/api/member'
import ExportJsonExcel from 'js-export-excel'

export default {
  name: 'WholeVehicleList',
  data() {
    return {
      loading: false,
      noteLoading: false,
      searchForm: {
        policyholder: '',
        beneficiary: '',
        mobile: '',
        policyNo: '',
        carNo: '',
        insuranceDateRange: [],
        status: '',
        effectiveDateRange: [],
        coverage: '',
        beginDistance: '',
        endDistance: '',
        channel: ''
      },
      tableData: [],
      noteList: [],
      noteDialogVisible: false,
      newNoteContent: '',
      currentOrderId: '',
      currentUserId: '',
      premiumTotal: 0,
      multipleSelection: [],
      pagination: {
        currentPage: 1,
        pageSize: 15,
        total: 0
      },
      channelList: [],
      selectedChannel: null
    }
  },
  created() {
    this.fetchData()
    this.fetchChannelList()
  },
  methods: {
    // 获取数据
    async fetchData() {
      // 与老项目保持一致的获取数据逻辑
      this.loading = true
      try {
        const params = {
          page: this.pagination.currentPage,
          rows: this.pagination.pageSize,
          platform_type: 8, // 整车保平台类型
          ...this.buildSearchParams()
        }
        
        const res = await zcbOrderList(params)
        this.tableData = res.rows || []
        this.pagination.total = res.total || 0
        this.premiumTotal = res.sum || 0
      } catch (error) {
        console.error('获取整车保订单列表失败:', error)
        this.$message.error('获取数据失败')
      } finally {
        this.loading = false
      }
    },
    
    // 构建搜索参数
    buildSearchParams() {
      const params = {}
      
      if (this.searchForm.policyholder) params.policyholder = this.searchForm.policyholder
      if (this.searchForm.beneficiary) params.beneficiary = this.searchForm.beneficiary
      if (this.searchForm.mobile) params.mobile = this.searchForm.mobile
      if (this.searchForm.policyNo) params.policy_no = this.searchForm.policyNo
      if (this.searchForm.carNo) params.plate_no = this.searchForm.carNo
      if (this.searchForm.insuranceDateRange && this.searchForm.insuranceDateRange.length === 2) {
        params.begin_date = Math.floor(this.searchForm.insuranceDateRange[0] / 1000)
        params.end_date = Math.floor(this.searchForm.insuranceDateRange[1] / 1000)
      }
      if (this.searchForm.status) params.status = this.searchForm.status
      if (this.searchForm.effectiveDateRange && this.searchForm.effectiveDateRange.length === 2) {
        params.effected_at = Math.floor(this.searchForm.effectiveDateRange[0] / 1000)
        params.expired_at = Math.floor(this.searchForm.effectiveDateRange[1] / 1000)
      }
      if (this.searchForm.coverage) params.coverage = this.searchForm.coverage
      if (this.searchForm.beginDistance) params.begin_distance = parseFloat(this.searchForm.beginDistance)
      if (this.searchForm.endDistance) params.end_distance = parseFloat(this.searchForm.endDistance)
      
      // 渠道商搜索 - 与老项目保持一致
      if (this.searchForm.channel && this.selectedChannel) {
        params.channel_id = this.selectedChannel.id
      }
      
      return params
    },
    
    // 渠道商模糊搜索方法
    async queryChannel(queryString, cb) {
      // 与老项目保持一致的渠道商模糊搜索逻辑
      try {
        // 改进模糊搜索逻辑，支持更灵活的匹配
        const results = queryString
          ? this.channelList.filter(item => {
              // 支持渠道名称和别名的模糊搜索
              const nameMatch = item.name && item.name.toLowerCase().includes(queryString.toLowerCase())
              const aliasMatch = item.alias && item.alias.toLowerCase().includes(queryString.toLowerCase())
              return nameMatch || aliasMatch
            })
          : this.channelList
        cb(results)
      } catch (error) {
        console.error('获取渠道列表失败:', error)
        cb([])
      }
    },
    
    // 获取渠道列表
    async fetchChannelList() {
      // 与老项目保持一致的获取渠道列表逻辑
      try {
        const res = await getChannelList()
        this.channelList = res.rows || []
      } catch (error) {
        console.error('获取渠道列表失败:', error)
      }
    },
    
    // 渠道商选择事件
    handleChannelSelect(item) {
      // 与老项目保持一致的渠道商选择逻辑
      this.selectedChannel = item
    },
    
    // 搜索
    handleSearch() {
      // 与老项目保持一致的搜索逻辑
      this.pagination.currentPage = 1
      this.fetchData()
    },
    
    // 重置
    handleReset() {
      // 与老项目保持一致的重置逻辑
      this.searchForm = {
        policyholder: '',
        beneficiary: '',
        mobile: '',
        policyNo: '',
        carNo: '',
        insuranceDateRange: [],
        status: '',
        effectiveDateRange: [],
        coverage: '',
        beginDistance: '',
        endDistance: '',
        channel: ''
      }
      this.selectedChannel = null
      this.pagination.currentPage = 1
      this.fetchData()
    },
    
    // 导出Excel
    async handleExportExcel() {
      // 与老项目保持一致的导出Excel逻辑
      try {
        const params = {
          platform_type: 8,
          ...this.buildSearchParams()
        }
        
        // 获取完整数据用于导出
        const res = await zcbExportOrder(params)
        
        if (res.rows && res.rows.length > 0) {
          // 使用ExportJsonExcel导出数据
          const exportExcel = new ExportJsonExcel({
            fileName: '睿保整车保订单',
            datas: [{
              sheetData: res.rows.map(item => ({
                '保险人': item.policyholder,
                '被保险人': item.beneficiary,
                '渠道': item.channel_name ? `${item.channel_name}(${item.alias})` : item.alias,
                '保单号': item.policy_no,
                '保单种类': this.formatPolicyType(item.type),
                '保单类型': item.is_trial ? '体验' : '正式',
                '来源': this.formatSource(item.source),
                '保额': this.formatCoverage(item.coverage),
                '车牌号': this.formatPlateNo(item),
                '运输路径': this.formatHaulway(item),
                '距离': this.formatDistance(item.distance),
                '运费（元）': this.formatMoney(item.carriage),
                '原价（元）': this.formatMoney(item.price),
                '实付（元）': this.formatMoney(item.pay_price),
                '投保时间': this.formatDate(item.created_at),
                '保单状态': this.formatStatus(item.status),
                '生效时间': this.formatDate(item.effected_at),
                '结束时间': this.formatDate(item.expired_at)
              })),
              sheetName: 'sheet',
              sheetHeader: ['保险人', '被保险人', '渠道', '保单号', '保单种类', '保单类型', '来源', '保额', '车牌号', '运输路径', '距离', '运费（元）', '原价（元）', '实付（元）', '投保时间', '保单状态', '生效时间', '结束时间']
            }]
          })
          exportExcel.saveExcel()
          this.$message.success('导出成功')
        } else {
          this.$message.warning('没有数据可导出')
        }
      } catch (error) {
        console.error('导出失败:', error)
        this.$message.error('导出失败')
      }
    },
    
    // 查看投保人详情
    viewPolicyholderDetail(name) {
      // 与老项目保持一致的查看投保人详情逻辑
      this.$message.info(`查看投保人详情: ${name}`)
      // 实际项目中这里应该跳转到用户详情页面
    },
    
    // 查看订单详情
    viewOrderDetail(orderId) {
      // 与老项目保持一致的查看订单详情逻辑
      this.$message.info(`查看订单详情，ID: ${orderId}`)
      // 实际项目中这里应该跳转到订单详情页面
    },
    
    // 手动回传保单信息
    async handlePolicyCallback(orderId) {
      // 与老项目保持一致的手动回传逻辑
      this.$confirm('您确定要手动回传吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const res = await zcbPolicyCallback({
            order_id: orderId,
            product_alias: 'zcb'
          })
          if (res.err_code === 0) {
            this.$message.success('修改回传成功')
            this.fetchData()
          } else {
            this.$message.error(res.err_msg || '回传失败')
          }
        } catch (error) {
          console.error('手动回传失败:', error)
          this.$message.error('回传失败')
        }
      }).catch(() => {
        this.$message.info('已取消回传')
      })
    },
    
    // 处理备注
    handleNote(orderId, userId) {
      // 与老项目保持一致的备注处理逻辑
      this.currentOrderId = orderId
      this.currentUserId = userId
      this.noteDialogVisible = true
      // 这里应该获取备注列表数据
      this.noteList = []
    },
    
    // 添加备注
    handleAddNote() {
      // 与老项目保持一致的添加备注逻辑
      if (!this.newNoteContent.trim()) {
        this.$message.warning('请输入备注内容')
        return
      }
      
      // 这里应该调用添加备注的接口
      this.$message.success('添加备注成功')
      this.newNoteContent = ''
    },
    
    // 备注对话框关闭
    handleNoteDialogClose() {
      // 与老项目保持一致的备注对话框关闭逻辑
      this.newNoteContent = ''
      this.currentOrderId = ''
      this.currentUserId = ''
      this.noteList = []
    },
    
    // 多选
    handleSelectionChange(val) {
      // 与老项目保持一致的多选逻辑
      this.multipleSelection = val
    },
    
    // 分页大小变化
    handleSizeChange(val) {
      // 与老项目保持一致的分页大小变化逻辑
      this.pagination.pageSize = val
      this.fetchData()
    },
    
    // 当前页变化
    handleCurrentChange(val) {
      // 与老项目保持一致的当前页变化逻辑
      this.pagination.currentPage = val
      this.fetchData()
    },
    
    // 保单种类格式化
    policyTypeFormat(row, column, cellValue) {
      return this.formatPolicyType(cellValue)
    },
    
    formatPolicyType(value) {
      // 与老项目保持一致的保单种类格式化逻辑
      if (value == 2) {
        return "整车保"
      } else if (value == 8) {
        return "无忧保"
      } else {
        return ""
      }
    },
    
    // 保单类型格式化
    policyTrialFormat(row, column, cellValue) {
      return cellValue ? "体验" : "正式"
    },
    
    // 来源格式化
    sourceFormat(row, column, cellValue) {
      return this.formatSource(cellValue)
    },
    
    formatSource(value) {
      // 与老项目保持一致的来源格式化逻辑
      const sourceMap = {
        1: 'PC',
        2: 'Mobile',
        4: 'iOS',
        8: 'Android',
        16: 'API'
      }
      return sourceMap[value] || ""
    },
    
    // 保额格式化
    coverageFormat(row, column, cellValue) {
      return this.formatCoverage(cellValue)
    },
    
    formatCoverage(value) {
      // 与老项目保持一致的保额格式化逻辑
      return value ? (value / 10000) + "万" : ""
    },
    
    // 车牌号格式化
    plateNoFormat(row, column, cellValue) {
      return this.formatPlateNo(row)
    },
    
    formatPlateNo(row) {
      // 与老项目保持一致的车牌号格式化逻辑
      if (row.plate_extra_no == "") {
        return "头:" + row.plate_no
      } else {
        return "头:" + row.plate_no + "  挂:" + row.plate_extra_no
      }
    },
    
    // 运输路线格式化
    haulwayFormat(row, column, cellValue) {
      return this.formatHaulway(row)
    },
    
    formatHaulway(row) {
      // 与老项目保持一致的运输路线格式化逻辑
      return row.start_province + row.start_city + "-" + row.end_province + row.end_city
    },
    
    // 距离格式化
    distanceFormat(row, column, cellValue) {
      return this.formatDistance(cellValue)
    },
    
    formatDistance(value) {
      // 与老项目保持一致的距离格式化逻辑
      return value ? value + "公里" : ""
    },
    
    // 金额格式化
    moneyFormat(row, column, cellValue) {
      return this.formatMoney(cellValue)
    },
    
    formatMoney(value) {
      // 与老项目保持一致的金额格式化逻辑
      if (value != null) {
        return (value / 100).toFixed(2)
      }
      return "0.00"
    },
    
    // 日期格式化
    dateFormat(row, column, cellValue) {
      return this.formatDate(cellValue)
    },
    
    formatDate(value) {
      // 与老项目保持一致的日期格式化逻辑
      if (value != null && new Date(value).getFullYear() != 1) {
        return formatDate(value)
      }
      return ""
    },
    
    // 状态格式化
    statusFormat(row, column, cellValue) {
      return this.formatStatus(cellValue)
    },
    
    formatStatus(value) {
      // 与老项目保持一致的状态格式化逻辑
      const statusMap = {
        1: '未支付',
        2: '已取消',
        4: '生效',
        8: '完成',
        16: '理赔中',
        32: '理赔完成'
      }
      return statusMap[value] || ""
    }
  }
}
</script>

<style lang="less" scoped>
.whole-vehicle-list {
  padding: 20px;
  
  .search-toolbar {
    margin-bottom: 20px;
  }
  
  .premium-total {
    margin-bottom: 20px;
    font-size: 16px;
    font-weight: bold;
    
    .total-amount {
      color: #ff0000;
    }
  }
  
  .link {
    color: #409EFF;
    cursor: pointer;
    
    &:hover {
      text-decoration: underline;
    }
  }
  
  .note-content {
    .add-note {
      margin-top: 20px;
    }
  }
}
</style>
